export var capList = function (items, max) {
    if (max === void 0) { max = 6; }
    return items.slice(0, max);
};
export var buildShowingSubtitle = function (shown, total) { return "Showing ".concat(shown, " of ").concat(total); };
